import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationPayload } from "@/types/common";

interface NotificationState {
  unreadCount: number;
  lastUpdated: number;
  shouldRefetch: boolean;
  lastReceivedNotification: NotificationPayload | null;
}

const initialState: NotificationState = {
  unreadCount: 0,
  lastUpdated: 0,
  shouldRefetch: false,
  lastReceivedNotification: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
      state.lastUpdated = Date.now();
      state.shouldRefetch = true;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    triggerRefresh: (state) => {
      state.lastUpdated = Date.now();
      state.shouldRefetch = true;
    },
    setRefetchFlag: (state, action: PayloadAction<boolean>) => {
      state.shouldRefetch = action.payload;
    },
    setLastReceivedNotification: (
      state,
      action: PayloadAction<NotificationPayload>,
    ) => {
      state.lastReceivedNotification = action.payload;
    },
  },
});

export const {
  setUnreadCount,
  incrementUnreadCount,
  decrementUnreadCount,
  triggerRefresh,
  setRefetchFlag,
  setLastReceivedNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
